<template>
  <div :class="wrapperClass" role="alert">
    <row class="mb-0">
      <prefix v-if="$slots.prefix">
        <slot name="prefix"></slot>
      </prefix>
      <slot name="message">
        <column class="p-sm" :class="{'font-weight-normal': !bold}">
          <slot>
            <ul>
              <li v-for="(m, ind) in fullMessages" :ref="`message-${ind}`" v-html="m"></li>
            </ul>
          </slot>
        </column>
      </slot>
      <suffix v-if="dismissable" type="button" class="btn-icon grey-to-red close" data-dismiss="alert">
        <span class="sr-only">Dismiss Alert Button</span>
        <icon class="times"></icon>
      </suffix>
    </row>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {ArrayHelper} from "~/helpers/arrayHelper";
  import {Hash} from "~/interfaces/hashInterfaces";

  type statusString = "danger" | "success" | "neutral" | "warning" | "blue" | "info";

  export default Vue.extend({
    props: {
      messages: {
        type: [Object, String, Array, Function],
        default: () => ({})
      },
      dismissable: {
        type: Boolean,
        default: false
      },
      status: {
        type: String as () => statusString,
        default: "danger"
      },
      hookClass: {
        type: String,
        default: null,
      },
      bold: {
        type: Boolean,
        default: false,
      },
    },
    mounted(){},
    computed: {
      fullMessages(): string[] {
        if (Array.isArray(this.messages)) {
          return this.messages;
        } else if (typeof this.messages === 'object') {
          return Object.keys(this.messages).map(key => {
            return ArrayHelper.toSentence(this.messages[key]);
          });
        } else if (['string', 'function'].includes(typeof this.messages)){
          return [this.messages];
        }
      },
      wrapperClass(): Hash {
        return {
          alert: true,
          "alert-dismissable": this.dismissable,
          fade: true,
          show: true,
          //status classes
          danger: this.status === "danger",
          success: this.status === "success",
          neutral: this.status === "neutral",
          warning: this.status === "warning",
          'alert-info': this.status === "info",
          'blue text-blue': this.status === "blue",
        }
      }
    },
  });
</script>